export const PAYMENT_METHODS = {
  CREDIT_DEBIT_WITH_CHECKOUT: 'CreditDebitWithCheckout',
  TABBY: 'Tabby',
};

/**
 * Query param that mirrors an open listing preview drawer, e.g. `/en/listings?preview=23421312`.
 * Purely a UI concern — `mapQueryParams` strips it so it never reaches a listings API request.
 */
export const LISTING_PREVIEW_QUERY_PARAM = 'preview';
